module.exports = __webpack_public_path__ + "img/list-bg.3b71e6dc.png";